module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Neil Gowan-96362dab5c9f008b2b62c88981694ae9.jpg";